import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { SsUser } from "src/app/models/secretServer/SsUser";

@Component({
    selector: 'request-details-reactivate-secret-user',
    templateUrl: './request-details-reactivate-secret-user.component.html'
})

export class RequestDetailsReactivateSecretUser implements OnChanges {
    @Input() requestData: SsUser;
    @Output() doneLoading = new EventEmitter<boolean>();
    requestInfo: any;
    constructor(
    ) { }

    async ngOnChanges(): Promise<void> {
        if (this.requestData) {
            this.requestInfo = {
                id: this.requestData.id,
                userName: this.requestData.userName,
                displayName: this.requestData.displayName,
                lastLogin: this.requestData.lastLogin,
                created: this.requestData.created
            };
            this.isDoneLoading();
        }
    }

    isDoneLoading() {
        this.doneLoading.emit(true);
    }
}
